export default "__VITE_ASSET__C9cMFGQV__"